export enum Color {
  Primary   = "primary",
  Secondary = "secondary",
  Error     = "error",
  Text = "text",
}
